import MessageBox from "sap/m/MessageBox";
import { ErrorStringifier } from "./ErrorStringifer.service";

export class ErrorHandler {
  static async handleError(
    ex: any,
    options: {
      title?: string;
      message?: string;
      onRetry?: () => void;
      onAbort?: () => void;
      ignorable?: boolean;
    } = {}
  ) {
    options = { ...{ ignorable: false }, ...options };

    if (ex.status === 401 || ex.statusCode === 401) return;

    const actions: Array<keyof typeof MessageBox.Action> = [];
    let emphasizedAction = MessageBox.Action.OK;

    if (options.ignorable) {
      actions.unshift(MessageBox.Action.IGNORE);
      emphasizedAction = MessageBox.Action.IGNORE;
    }

    if (options.onRetry) {
      actions.unshift(MessageBox.Action.RETRY);
      emphasizedAction = MessageBox.Action.RETRY;
    }

    if (options.onAbort) {
      actions.unshift(MessageBox.Action.ABORT);
    }

    MessageBox.error(options.message || ErrorStringifier.getMessage(ex), {
      title: options.title,
      details: ErrorStringifier.getDetails(ex),
      actions: actions,
      closeOnNavigation: false,
      emphasizedAction: emphasizedAction,
      onClose: async (result: any) => {
        if (result === MessageBox.Action.RETRY) {
          await options.onRetry();
        } else if (result === MessageBox.Action.ABORT) {
          await options.onAbort();
        }
      },
    });
  }
}
